import { useMutation } from "@apollo/client";
import { Button } from "@blueprintjs/core";
import { useState } from "react";
import {
  ArticleSource,
  CreateArticleSourceInput,
  UpdateArticleSourceInput,
} from "../../../api/schema";
import { FlexGrow, FlexRowStretch } from "../../../components/flex/Flex";
import {
  DeleteModal,
  DeleteStateHelper,
} from "../../../components/form/DeleteModal";
import {
  InputFormMode,
  UpdateStateHelper,
  ValuesVariables,
} from "../../../components/form/InputForm";
import { InputModal } from "../../../components/form/InputModal";
import { Table } from "../../../components/Table";
import { UserLanguage } from "../../../lang/lang";
import {
  CreateArticleSourceMutation,
  DeleteArticleSourceMutation,
  DeleteArticleSourceResponse,
  UpdateArticleSourceMutation,
} from "../../ArticleSources/graphql";
import { CreateArticleSourceModal } from "../modals/CreateArticleSource";
import { ArticleViewResponse } from "../helper/graphql";
import { UpdateArticleSourceModalKeys } from "../modals/modals";
import { PartSourceViewTableColumns } from "../List/table";

//TODO: "https://easyeda.com/api/eda/product/search?keyword=C96123" DO IT!

export const ArticleSourcesList = (props: {
  data: ArticleViewResponse;
  refetch: () => void;
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [updateArticleSourceState, setUpdateArticleSourceState] = useState<
    UpdateStateHelper<ArticleSource>
  >({ open: false, item: undefined });
  const [deleteModalState, setDeleteModalState] = useState<DeleteStateHelper>({
    open: false,
    id: undefined,
    prettyPrint: undefined,
  });

  const [createArticleSource] = useMutation<
    ArticleSource,
    ValuesVariables<CreateArticleSourceInput>
  >(CreateArticleSourceMutation);

  const [updateArticleSource] = useMutation<
    ArticleSource,
    ValuesVariables<UpdateArticleSourceInput>
  >(UpdateArticleSourceMutation);
  const [deleteArticleSource] = useMutation<DeleteArticleSourceResponse>(
    DeleteArticleSourceMutation
  );

  const refetch = () => {
    props.refetch();
  };

  return (
    <div>
      <h3>{UserLanguage().pages.articleSource.list}</h3>
      <CreateArticleSourceModal
        bundle={{
          open: createModalOpen,
          onClose: () => setCreateModalOpen(false),
          mutation: createArticleSource,
          onSuccess: () => refetch(),
          data: props.data,
        }}
      />
      <InputModal<ArticleSource, ArticleSource, UpdateArticleSourceInput>
        keys={UpdateArticleSourceModalKeys(props.data)}
        open={updateArticleSourceState.open}
        input={updateArticleSourceState.item}
        texts={UserLanguage().pages.articleSource.actions}
        onClose={() =>
          setUpdateArticleSourceState({ open: false, item: undefined })
        }
        mutation={updateArticleSource}
        reformId={["distributor"]}
        onSuccess={() => {
          refetch();
          setUpdateArticleSourceState({ open: false, item: undefined });
        }}
        resetOnClose
        mode={InputFormMode.Edit}
      />
      <DeleteModal<DeleteArticleSourceResponse>
        id={deleteModalState.id}
        open={deleteModalState.open}
        mutation={(id) => deleteArticleSource({ variables: { id } })}
        texts={UserLanguage().pages.articleSource.actions}
        resetOnClose
        onClose={() => {
          setDeleteModalState({ open: false, id: undefined });
        }}
        onSuccess={() => {
          setDeleteModalState({ open: false, id: undefined });
          refetch();
        }}
        type={UserLanguage().data.articleSource.label}
        prettyPrint={deleteModalState.prettyPrint}
      />
      <Table<ArticleSource>
        columns={PartSourceViewTableColumns(
          setUpdateArticleSourceState,
          setDeleteModalState
        )}
        items={props.data.article.sources}
      />
      <FlexRowStretch style={{ marginTop: 20 }}>
        <FlexGrow />
        <div>
          <Button
            intent="success"
            icon="plus"
            onClick={() => setCreateModalOpen(true)}
          >
            {UserLanguage().actions.create}
          </Button>
        </div>
      </FlexRowStretch>
    </div>
  );
};
